<template><div class="MMV">
    <div class="MMV__head" :class="{ _open: isHeadExpanded }" @click="HeadExpand_click">
        <div class="MMV__head-open" >
            <vDown class="vicon-black MMV__head-open__icon"  />
        </div>
        <div class="MMV__head__title">
            <slot>Название поля</slot>
        </div>
        <div v-if="choosedset.size" class="MMV__head-count">{{choosedset.size}}</div>
        
    </div>

    <template v-if="isHeadExpanded">

        <div v-if="choosedset.size && needSeach" class="MMV__selected">
            <MyMultiVertOption  v-for="option in selected" :key="option.id" :item="option" @input="set_option"   />
        </div>

        <div v-if="needSeach" class="MMV__searchbox">
            <input type="text" :placeholder="props.placeholder" class="MMV__searchbox__input" v-model="search_calc" /> 
            <button v-if="search_calc" class="MMV__searchbox-icon-reset" @click.stop.prevent="reset_click"><vReset class="vicon-red reset" /></button>
            <vSearch class="vicon-greyfigma MMV__searchbox-search" />
        </div>

        <div class="MMV__aftersearchbox" :class="{ _open: isFootExpanded }">
            <MyMultiVertOption  v-for="option in aftersearchbox" :key="option.id" :item="option" @input="set_option"   />
        </div>

        <div v-if="needSeach && needFootExpand && !search_calc" class="MMV__footer" :class="{ _open: isFootExpanded }" @click="FootExpand_click">
            <button class="MMV__footer-title">
                {{isFootExpanded ? 'Cкрыть' : 'Показать все'}}
            </button>
            <vDown class="vicon-bluefigma MMV__footer-icon"  />
        </div>

    </template>
</div></template>

<style lang="scss" src="./MyMultiVert.scss"></style>

<script setup>
import {ref, computed, unref} from 'vue'    
import vSearch from '@/assets/vicons/search.vue'
import vDown from '@/assets/vicons/chevron-down.vue'
import vReset from '@/assets/vicons/remove.vue'
import MyMultiVertOption from './MyMultiVertOption.vue'

const props = defineProps({
    list: Array, 
    choosed: [String], 
    placeholder: String,
    onlyone: {
        type: Boolean,
        default: false,
    },
    limit: {
        type: Number,
        default: 5,
    },
})
const emits = defineEmits([ 'input' ])

const choosedset = computed(()=>{
    let a = props.choosed ? props.choosed.split(",") : []
    let s = new Set(a)
    let skipold =  props.list.filter( ({id}) => s.has(id)  ).map( o => o.id )
    if (props.onlyone) {// только один можно выбрать
        skipold = skipold.slice(0,1)
    }
    let ret = new Set(skipold)
    return ret
})

const isHeadExpanded = ref(true) // по умолчанию показано
const isFootExpanded = ref(false) 
const needFootExpand = computed(()=>{
    let ret = props.limit > 0 && props.list.length > props.limit
    return ret
})
const needSeach = computed(()=>{
    let ret = !(props.limit<=5 && props.list.length <= props.limit)
    return ret
})
const search_str = ref('')



const FootExpand_click = () => {
    isFootExpanded.value = !isFootExpanded.value
}
const HeadExpand_click = () => {
    isHeadExpanded.value = !isHeadExpanded.value
}
const reset_click = () => {
    search_str.value = ''
}

const set_option = (id, newval)=> {
    let sele_old = unref(choosedset)
    let sele = new Set([...sele_old])
    if (newval) {
        if (props.onlyone) {
            sele.clear()
        }
        sele.add(id)
    } else {
        sele.delete(id)
    }

    if (!setsEqual(sele, sele_old)) {
        let val = Array.from(sele).sort().join(',') // добавили порядок. Неважно какой - главное чтобы один
        emits('input', val)
    }
}

const search_calc = computed({
    get() {
        return search_str.value
    },
    set(v) {
        search_str.value = v.trim()
    }
})

const selected = computed(()=>{
    return props.list.filter( ob => choosedset.value.has( ob.id )  ).map( ob => {
        return {...ob, selected: true}
    } )
})
const aftersearchbox = computed(()=>{
    let all = props.list
    let str = unref(search_str)
    let isE = unref(isFootExpanded)
    let sele = unref(choosedset)
    if (str) {// показываем все найденное
        str = escapeRegExp(str)
        str = str.replace(/[ -]+/g,".+")
        let pt = new RegExp(str, 'i')
        all = all.filter( ob => ob.name.match( pt  ) )
    } else if (!isE && props.limit > 0) {
        all = all.slice(0, props.limit )
    }
    all = all.map( ob => {
        let selected = sele.has( ob.id )
        return {...ob, selected}
    })
//console.log('all', all)    
    return all
})

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function setsEqual(a, b) {
  if (a.size !== b.size) return false;
  for (const value of a) {
    if (!b.has(value)) return false;
  }
  return true;
}

</script>
